/*
 * Cookie consent banner and consent-gated tracking.
 * Same cookie (cookie_consent = all | essential | none, 365 days) and tracking
 * IDs as the DDMN CMS sites, so a choice made on www.deltadentalmn.org carries
 * over. Framework-free so it drops into any DDMN front end unchanged.
 */

var COOKIE_NAME = 'cookie_consent';
var COOKIE_DAYS = 365;

/*
 * State GA4 plus the shared DDPA container. The site GTM containers and
 * StackAdapt belong to the Online Store only, so they are not loaded here.
 */
var GA4_IDS = { mn: 'G-KY0X9KZ29J', ne: 'G-NQ1X73LBYK' };
var GTM_DDPA_ID = 'GTM-NZV82B';

var trackingLoaded = false;

function readCookie () {
  var match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=(all|essential|none)'));
  return match ? match[1] : null;
}

function writeCookie (consent) {
  var expires = new Date(Date.now() + COOKIE_DAYS * 864e5).toUTCString();
  document.cookie = COOKIE_NAME + '=' + consent + '; expires=' + expires + '; path=/; SameSite=Lax';
}

function addScript (src) {
  var script = document.createElement('script');
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}

function loadTracking () {
  var ga4Id = window.location.hostname.indexOf('deltadentalne.org') > -1 ? GA4_IDS.ne : GA4_IDS.mn;

  // Google Analytics GA4
  addScript('https://www.googletagmanager.com/gtag/js?id=' + ga4Id);
  window.gtag('js', new Date());
  window.gtag('config', ga4Id);

  // Shared DDPA Tag Manager container
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });
  addScript('https://www.googletagmanager.com/gtm.js?id=' + GTM_DDPA_ID);
}

function applyConsent (consent) {
  var granted = consent === 'all' ? 'granted' : 'denied';
  window.gtag('consent', 'update', { analytics_storage: granted, ad_storage: granted });
  if (consent === 'all' && !trackingLoaded) {
    trackingLoaded = true;
    loadTracking();
  }
}

function button (className, label, onClick) {
  var el = document.createElement('button');
  el.type = 'button';
  el.className = 'cookie-btn ' + className;
  el.textContent = label;
  el.addEventListener('click', onClick);
  return el;
}

function showBanner () {
  var overlay = document.createElement('div');
  overlay.className = 'cookie-consent-overlay';
  overlay.innerHTML =
    '<div class="cookie-consent-container" role="dialog" aria-label="Cookie consent" aria-describedby="cookieConsentDescription">' +
      '<p class="cookie-consent-text" id="cookieConsentDescription">' +
        'We use cookies to enhance your browsing experience and analyze our traffic. ' +
        'By clicking "Accept All Cookies", you consent to our use of cookies.' +
      '</p>' +
      '<div class="cookie-consent-buttons"><div class="cookie-btn-options"></div></div>' +
    '</div>';

  var container = overlay.querySelector('.cookie-consent-container');
  var buttons = overlay.querySelector('.cookie-consent-buttons');
  var options = overlay.querySelector('.cookie-btn-options');

  function choose (consent) {
    writeCookie(consent);
    applyConsent(consent);
    container.className += ' closing';
    setTimeout(function () {
      overlay.parentNode.removeChild(overlay);
    }, 500); // matches the slideDown animation
  }

  buttons.insertBefore(button('cookie-btn-accept', 'Accept All Cookies', function () { choose('all'); }), options);
  options.appendChild(button('cookie-btn-outline', 'Essential Cookies Only', function () { choose('essential'); }));
  options.appendChild(button('cookie-btn-outline', 'Reject All Cookies', function () { choose('none'); }));

  document.body.appendChild(overlay);
}

export default function initCookieConsent () {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () {
    window.dataLayer.push(arguments);
  };
  window.gtag('consent', 'default', { analytics_storage: 'denied', ad_storage: 'denied' });

  var stored = readCookie();
  if (stored) {
    applyConsent(stored);
  } else if (document.body) {
    showBanner();
  } else {
    document.addEventListener('DOMContentLoaded', showBanner);
  }
}



//////////////////
// WEBPACK FOOTER
// ./src/js/cookie-consent.js
// module id = 28
// module chunks = 0